// Constantes relacionadas à geração de código

// Templates de linguagens suportadas
export const codeTemplates = {
  javascript: 'generateJavaScript',
  python: 'generatePython',
  java: 'generateJava',
  csharp: 'generateCSharp',
  php: 'generatePHP',
  curl: 'generateCurl'
}

// Valores de exemplo por tipo de dados para JavaScript
export const exampleValues = {
  string: 'exemplo',
  number: '123',
  integer: '123',
  boolean: 'true',
  array: '[]',
  object: '{}',
  default: 'valor'
}

// Valores de exemplo formatados para JavaScript
export const formattedExampleValues = {
  string: '"exemplo"',
  number: '123',
  integer: '123',
  boolean: 'true',
  array: '[]',
  object: '{}',
  default: '"valor"'
}

// Valores de exemplo para Python
export const pythonExampleValues = {
  string: '"exemplo"',
  number: '123',
  integer: '123',
  boolean: 'True',
  array: '[]',
  object: '{}',
  default: '"valor"'
}

// Valores de exemplo para PHP
export const phpExampleValues = {
  string: '"exemplo"',
  number: '123',
  integer: '123',
  boolean: 'true',
  array: '[]',
  object: '[]',
  default: '"valor"'
}

// Valores de exemplo para C#
export const csharpExampleValues = {
  string: '"exemplo"',
  number: '123',
  integer: '123',
  boolean: 'true',
  array: 'new List<object>()',
  object: 'new {}',
  default: '"valor"'
}

// Valores de exemplo para JSON
export const jsonExampleValues = {
  string: '"exemplo"',
  number: '123',
  integer: '123',
  boolean: 'true',
  array: '[]',
  object: '{}',
  default: '"valor"'
}

// Métodos HTTP que suportam body
export const httpMethodsWithBody = ['POST', 'PUT', 'PATCH']

// Mapeamento de métodos HTTP para C#
export const csharpHttpMethods = {
  GET: 'GetAsync',
  POST: 'PostAsync',
  PUT: 'PutAsync',
  DELETE: 'DeleteAsync',
  default: 'SendAsync'
}